import { combineReducers,  createStore } from '@reduxjs/toolkit'
import BusinessesReducer from '../businesses/PushBusinessesReducer'

const Reducer = combineReducers({
    BusinessesReducer
  });

 const store = createStore(Reducer);
 export default store